export default __webpack_public_path__ + "static/media/sailing_boat_middle_calm_sea_by_hills_captured_switzerland.3b4fe100.webp";